import { useQuery } from '@tanstack/react-query'
import { fetchIpdObjects } from '../../../api/core/ipdObjects'
import { IpdObject } from '../../../entities/IpdObject'

interface UseIpdObjectsOptions {
  livingComplexId: string
  name?: string
}

export const useIpdObjects = ({
  livingComplexId,
  name
}: UseIpdObjectsOptions) =>
  useQuery<IpdObject[]>({
    queryKey: ['ipd-objects', livingComplexId, name],
    queryFn: () =>
      fetchIpdObjects({
        livingComplexId,
        name
      }),
    enabled: !!livingComplexId,
    staleTime: 5 * 60 * 1000
  })
